"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onFileDrop = exports.useFileDrop = exports.FileDropProvider = void 0;
var FileDrop_1 = require("./FileDrop");
Object.defineProperty(exports, "FileDropProvider", { enumerable: true, get: function () { return FileDrop_1.FileDropProvider; } });
Object.defineProperty(exports, "useFileDrop", { enumerable: true, get: function () { return FileDrop_1.useFileDrop; } });
var onFileDrop_1 = __importDefault(require("./onFileDrop"));
exports.onFileDrop = onFileDrop_1.default;
